import { VehicleNumberPlateType } from '~/shared';
import {
	StyledCircle,
	StyledContainer,
	StyledLetters,
	StyledNumberContainer,
	StyledStroke,
} from './PreviewCustom.styled';

const PreviewCustom = ({
	type,
	number,
}: {
	type: VehicleNumberPlateType;
	number: string;
}) => {
	const isBlack = type === VehicleNumberPlateType.CustomBlack;

	return (
		<StyledContainer $black={isBlack}>
			<StyledStroke $black={isBlack} />
			<StyledCircle $position="left" $black={isBlack} />
			<StyledCircle $position="right" $black={isBlack} />
			<StyledNumberContainer>
				<StyledLetters $black={isBlack}>{number}</StyledLetters>
			</StyledNumberContainer>
		</StyledContainer>
	);
};

export { PreviewCustom };
